'use client'

import { NotFound as NotFoundClient } from '@pattern-library/complexUI/NotFound'

export default function NotFound() {
  // Inspiration: https://codepen.io/tripti1410/pen/jOBEYXX
  return <NotFoundClient />
}
